import React, { useCallback, useMemo, useRef } from 'react';

import { Box } from '@chakra-ui/react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { showOKRDetails } from 'components/RabbitOKRSidePanel/okrPanelControlSlice';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ObjectiveKRCellOneOnOne } from './ObjectiveKRCellOneOnOne';

const GoalsOneOnOneAgGrid = ({ data, refetchCascadedViewData = () => {} }) => {
  const gridRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();

  const defaultColDef = useMemo(
    () => ({
      autoHeight: true,
      wrapText: true,
    }),
    []
  );

  const autoGroupColumnDef = useMemo(
    () => ({
      headerName: 'Objectives',
      minWidth: 300,
      flex: 1,
      filter: true,
      cellStyle: { height: 'auto' },
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: ObjectiveKRCellOneOnOne,
      },
      //  hacky way to make sure that the auto group column is updated on the basis of the valueGetter
      valueGetter: (data) =>
        data?.data?.title + data?.data?.progressLevel + data?.data?.progress + data?.data?.avgProgressPercentage,
    }),
    []
  );
  const getDataPath = useMemo(() => (data) => data.hierarchy, []);

  const rowClickHandler = ({ data }) => {
    const { type, uuid } = data ?? {};
    dispatch(
      showOKRDetails({
        id: uuid,
        type,
        onDelete: refetchCascadedViewData,
        onUpdate: refetchCascadedViewData,
        history,
      })
    );
  };

  const getRowId = useCallback(({ data }) => data?.uuid, []);

  const getRowStyle = (params) => {
    if (params?.data?.unMasked) {
      return { cursor: 'pointer' };
    }
  };

  return (
    <Box className="ag-theme-alpine" style={{ width: '100%' }}>
      <AgGridReact
        ref={gridRef}
        rowData={data}
        columnDefs={[]}
        defaultColDef={defaultColDef}
        autoGroupColumnDef={autoGroupColumnDef}
        treeData
        animateRows={false}
        groupDefaultExpanded={-1}
        getDataPath={getDataPath}
        domLayout="autoHeight"
        onRowClicked={rowClickHandler}
        getRowId={getRowId}
        getRowStyle={getRowStyle}
        headerHeight={0}
      />
    </Box>
  );
};

export { GoalsOneOnOneAgGrid };
